export const minimise = () => (
  <path
    d="M4 21h16"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
